import { CanActivate, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Injectable } from '@angular/core';

import { LoginService } from '../login.service';

@Injectable()
export class MustBeLoggedInGuardService implements CanActivate, CanLoad {

  constructor(
    private loginService: LoginService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    let callBackUrl = state.url;
    //console.log('MustBeLoggedInGuardService, canActivate', route.url, callBackUrl);

    return new Promise<boolean>((resolve, reject) => {
      //console.log('MustBeLoggedInGuardService, ensureLoggedIn()');

      this.loginService.ensureLoggedIn(callBackUrl).then((result) => {
        // Login service by default is redirecting to identity server page, current implementation is really fire and forget,
        // this will wait for redirect to happen (current state) and will still work in case logic is rewritten

        //console.log('MustBeLoggedInGuardService, ensureLoggedIn(), resolved');

        resolve(true);
      });
    });
  }

  canLoad(route: Route): Promise<boolean> | boolean {
    let callBackUrl = `/${route.path}`;
    //console.log('MustBeLoggedInGuardService, canLoad()', callBackUrl);

    return new Promise<boolean>((resolve, reject) => {
      //console.log('MustBeLoggedInGuardService, canLoad()');

      this.loginService.ensureLoggedIn(callBackUrl).then((result) => {

        //console.log('MustBeLoggedInGuardService, canLoad(), resolved');

        resolve(true);
      });
    });
  }
}
